import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "windy-container" }

import { ref, watch, onBeforeUnmount, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'WindyLayer',
  props: {
    devices: {},
    zoom: {},
    center: {},
    layer: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const windyIframe = ref<HTMLIFrameElement | null>(null);
const publicPath = computed(() => process.env.BASE_URL || '/');
// windy.html is rewritten at container start with the current WINDY_KEY. A
// cache-buster per mount keeps a stale copy (browser heuristic cache, proxy)
// from serving a revoked key; the file is ~6 KB, so always fetching it is cheap.
const windySrc = `${publicPath.value}windy.html?v=${Date.now()}`;

function onIframeLoad() {
  if (!windyIframe.value || !windyIframe.value.contentWindow) return;

  const iframeWin = windyIframe.value.contentWindow;

  iframeWin.postMessage({
    type: 'INIT_WINDY',
    payload: {
      center: props.center ? [props.center.lat, props.center.lng] : [45.4642, 9.1900],
      zoom: props.zoom || 10,
      layer: props.layer || 'wind'
    }
  }, '*');

  updateMarkers();
}

function updateMarkers() {
  if (!windyIframe.value || !windyIframe.value.contentWindow) return;

  const sanitizedDevices = (props.devices || []).map(d => ({
    lat: d.lat || d.latitude || d.latest_data?.latitude,
    lng: d.lng || d.longitude || d.latest_data?.longitude,
    name: d.name,
    vin: d.vin
  }));

  windyIframe.value.contentWindow.postMessage({
    type: 'UPDATE_MARKERS',
    payload: sanitizedDevices
  }, '*');
}

watch(() => props.devices, () => {
  updateMarkers();
}, { deep: true });

watch(() => props.layer, (newLayer) => {
  if (!windyIframe.value || !windyIframe.value.contentWindow) return;
  
  windyIframe.value.contentWindow.postMessage({
    type: 'SET_OVERLAY',
    payload: newLayer
  }, '*');
});

function flyTo(lat: number, lng: number, zoom?: number) {
  if (!windyIframe.value || !windyIframe.value.contentWindow) return;
  windyIframe.value.contentWindow.postMessage({
    type: 'SET_CENTER',
    payload: { lat, lng, zoom }
  }, '*');
}

__expose({ flyTo });

onBeforeUnmount(() => {
  // Cleanup if needed
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      ref_key: "windyIframe",
      ref: windyIframe,
      src: windySrc,
      onLoad: onIframeLoad,
      class: "windy-iframe"
    }, null, 544)
  ]))
}
}

})